// Author Lidongxu
// Date 2025-07-01 13:49:44

class EmEpcTag {
    constructor({
                    id = null,
                    remark = '',
                    epcCode = '',
                    tagMaterialId = '',
                    tagBusinessCode = '',
                    bindId = '',
                    bindStatus = '',
                    isActive = '',
                    operatorId = '',
                    operateTime = ''
                }
                = {}) {
        this.id = id;
        this.remark = remark;
        this.epcCode = epcCode;
        this.tagMaterialId = tagMaterialId;
        this.tagBusinessCode = tagBusinessCode;
        this.bindId = bindId;
        this.bindStatus = bindStatus;
        this.isActive = isActive;
        this.operatorId = operatorId;
        this.operateTime = operateTime;
    }
}

function newEntity() {
    return new EmEpcTag();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.epc.emEpcTag.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.epc.emEpcTag.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'epcCode',
            label: 'label.em.epc.emEpcTag.grid.epcCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tagMaterialName',
            label: 'label.em.epc.emEpcTag.grid.tagMaterialName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tagMaterialType',
            label: 'label.em.epc.emEpcTag.grid.tagMaterialType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    { value: '0', text: '柔性' },
                    { value: '1', text: '硬质' }
                ]
            }
        },
        {
            key: 'tagSize',
            label: 'label.em.epc.emEpcTag.grid.tagSize',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'isReusable',
            label: 'label.em.epc.emEpcTag.grid.isReusable',
            sortable: true,
            form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tagBusinessCode',
            label: 'label.em.epc.emEpcTag.grid.tagBusinessCode',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '工具/刀具'},
                    {value: '2', text: '吊索具'},
                    {value: '3', text: '固定资产'},
                    {value: '4', text: '工装'},
                    {value: '5', text: '量器具'}
                ]
            }
        },
        {
            key: 'bindId',
            label: 'label.em.epc.emEpcTag.grid.bindId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bindStatus',
            label: 'label.em.epc.emEpcTag.grid.bindStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '已绑定'},
                    {value: '1', text: '未绑定'}
                ]
            }
        },
        {
            key: 'isActive',
            label: 'label.em.epc.emEpcTag.grid.isActive',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '启用'},
                    {value: '1', text: '停用'}
                ]
            }
        },
        {
            key: 'operatorId',
            label: 'label.em.epc.emEpcTag.grid.operatorId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operator',
            label: 'label.em.epc.emEpcTag.grid.operator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operateTime',
            label: 'label.em.epc.emEpcTag.grid.operateTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    epcCodeFilter: '',
    tagMaterialIdFilter: '',
    tagBusinessCodeFilter: '',
    bindIdFilter: '',
    bindStatusFilter: '',
    isActiveFilter: '',
    operatorIdFilter: '',
    operateTimeRteFilter: '',
    operateTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'epcCodeFilter',
        label: 'label.em.epc.emEpcTag.filter.epcCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tagMaterialIdFilter',
        label: 'label.em.epc.emEpcTag.filter.tagMaterialId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emEpcTagMaterial'
            , correspondingField: 'id'
        }
    },
    {
        key: 'tagBusinessCodeFilter',
        label: 'label.em.epc.emEpcTag.filter.tagBusinessCode',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '工具/刀具'},
                {value: '2', text: '吊索具'},
                {value: '3', text: '固定资产'},
                {value: '4', text: '工装'},
                {value: '5', text: '量器具'}
            ]
        }
    },
    {
        key: 'bindIdFilter',
        label: 'label.em.epc.emEpcTag.filter.bindId',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bindStatusFilter',
        label: 'label.em.epc.emEpcTag.filter.bindStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '已绑定'},
                {value: '1', text: '未绑定'}
            ]
        }
    },
    {
        key: 'isActiveFilter',
        label: 'label.em.epc.emEpcTag.filter.isActive',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '启用'},
                {value: '1', text: '停用'}
            ]
        }
    },
    {
        key: 'operatorIdFilter',
        label: 'label.em.epc.emEpcTag.filter.operatorId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'operateTimeRteFilter',
        label: 'label.em.epc.emEpcTag.filter.operateTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operateTimeLteFilter',
        label: 'label.em.epc.emEpcTag.filter.operateTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'remark',
        label: 'label.em.epc.emEpcTag.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'epcCode',
        label: 'label.em.epc.emEpcTag.entity.epcCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tagMaterialId',
        label: 'label.em.epc.emEpcTag.entity.tagMaterialId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , correspondingField: 'id'
        }
    },
    {
        key: 'tagBusinessCode',
        label: 'label.em.epc.emEpcTag.entity.tagBusinessCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '工具/刀具'},
                {value: '2', text: '吊索具'},
                {value: '3', text: '固定资产'},
                {value: '4', text: '工装'},
                {value: '5', text: '量器具'}
            ]
        }
    },
    {
        key: 'bindId',
        label: 'label.em.epc.emEpcTag.entity.bindId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bindStatus',
        label: 'label.em.epc.emEpcTag.entity.bindStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '已绑定'},
                {value: '1', text: '未绑定'}
            ]
        }
    },
    {
        key: 'isActive',
        label: 'label.em.epc.emEpcTag.entity.isActive',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '启用'},
                {value: '1', text: '停用'}
            ]
        }
    },
    {
        key: 'operatorId',
        label: 'label.em.epc.emEpcTag.entity.operatorId',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operateTime',
        label: 'label.em.epc.emEpcTag.entity.operateTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    EmEpcTag, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
